import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const ServiceCard = ({ service, onBookNow, onWhatsAppInquiry }) => {
  return (
    <div className="bg-card rounded-xl shadow-md hover:shadow-xl transition-all duration-300 overflow-hidden card-hover">
      <div className="relative h-48 md:h-56 lg:h-64 overflow-hidden">
        <Image
          src={service?.image}
          alt={service?.imageAlt}
          className="w-full h-full object-cover"
        />
        {service?.isPopular && (
          <div className="absolute top-4 right-4 bg-accent text-accent-foreground px-3 py-1 rounded-full text-xs font-semibold flex items-center gap-1">
            <Icon name="Star" size={14} />
            Popular
          </div>
        )}
      </div>
      <div className="p-4 md:p-6 lg:p-8">
        <div className="flex items-start justify-between mb-3">
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center">
              <Icon name={service?.icon} size={24} className="text-primary" />
            </div>
            <div>
              <h3 className="text-lg md:text-xl lg:text-2xl font-heading font-bold text-foreground">
                {service?.name}
              </h3>
              <p className="text-xs md:text-sm text-muted-foreground">
                {service?.category}
              </p>
            </div>
          </div>
        </div>

        <p className="text-sm md:text-base text-muted-foreground mb-4 line-clamp-2">
          {service?.description}
        </p>

        <div className="grid grid-cols-2 gap-3 mb-4">
          <div className="flex items-center gap-2 text-sm">
            <Icon name="Users" size={16} className="text-primary" />
            <span className="text-foreground font-medium">{service?.capacity}</span>
          </div>
          <div className="flex items-center gap-2 text-sm">
            <Icon name="Luggage" size={16} className="text-primary" />
            <span className="text-foreground font-medium">{service?.luggage}</span>
          </div>
        </div>

        <div className="bg-muted/50 rounded-lg p-3 mb-4">
          <div className="flex items-baseline gap-2">
            <span className="text-2xl md:text-3xl font-bold text-primary">
              ₹{service?.startingPrice}
            </span>
            <span className="text-sm text-muted-foreground">onwards</span>
          </div>
          <p className="text-xs text-muted-foreground mt-1">
            {service?.priceNote}
          </p>
        </div>

        <div className="flex flex-col sm:flex-row gap-2">
          <Button
            variant="default"
            size="default"
            iconName="Calendar"
            iconPosition="left"
            onClick={() => onBookNow(service)}
            fullWidth
            className="bg-action hover:bg-action/90"
          >
            Book Now
          </Button>
          <Button
            variant="outline"
            size="default"
            iconName="MessageCircle"
            iconPosition="left"
            onClick={() => onWhatsAppInquiry(service)}
            className="sm:w-auto whatsapp-pulse"
          >
            WhatsApp
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ServiceCard;